import { DisclaimerView } from './Disclaimer/DisclaimerView';

import DefaultLayout from '@/layouts/Default';
import { GetStartedNewView } from '@/src/views/GetStarted/GetStartedNew';

export function SlugDistribution(props) {
  const { contentType } = props;
  switch (contentType) {
    case 'disclaimerPage':
      SlugDistribution.Layout = DefaultLayout;
      return <DisclaimerView {...props} />;
    default:
      return <GetStartedNewView {...props} />;
  }
}
